import { render, staticRenderFns } from "./QuizResult.vue?vue&type=template&id=bda2eb7a&"
import script from "./QuizResult.vue?vue&type=script&lang=js&"
export * from "./QuizResult.vue?vue&type=script&lang=js&"
import style0 from "./QuizResult.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports